import {urlExtension} from '../shared-spa/utilities/url'

const ext = urlExtension()
// @ts-ignore
__webpack_public_path__ = `https://${ext === 'cc' ? 'cdn-app' : 'cdn'}.varium.${ext}/${ext === 'cc' ? '' : 'app/'}`

import('./root')
